import React from 'react';
import './Loader.css'
const Loader = () => {
  return (
    <div className="cube-container">
      <div className="cube">
        <div className="side"></div>
        <div className="side"></div>
        <div className="side"></div>
        <div className="side"></div>
        <div className="side"></div>
        <div className="side"></div>
      </div>
    </div>
  );
};

export default Loader;
